import { tw as n } from "../../../utils/tailwind.js";
import { isOdd as c, isEven as d } from "./gridLayout.helpers.js";
const f = ({ num: o, divisor: s }) => {
  const t = o % s;
  return { rest: t, isDivisible: t === 0 };
}, a = (o, s) => d(o) && c(s) || c(o) && d(s);
function g(o) {
  const { rest: s, isDivisible: t } = f({
    num: o,
    divisor: 4
  }), { rest: i, isDivisible: r } = f({
    num: o,
    divisor: 3
  });
  return t ? { cols: 4 } : r ? { cols: 3 } : s > i ? { cols: 4 } : s === i ? s === 1 ? { cols: 3 } : { cols: 4 } : { cols: 3 };
}
function w(o) {
  const { cols: s } = g(o), t = Math.floor(o / s), i = o % s, r = Array.from({ length: t }).fill(s);
  return i > 0 && r.push(i), { rows: r };
}
function h(o) {
  let s = 0;
  for (let t = 0; t < o.length; t++)
    s += o[t];
  return s;
}
function m(o) {
  const { rows: s } = w(o), t = s[0], i = s[s.length - 1], l = s.length >= 2 && i !== t, e = l ? h(s.slice(0, -1)) : void 0, u = l && a(t, i);
  return {
    nthElementShifted: e,
    columnsCount: u ? t * 2 : t,
    doubleColumns: u
  };
}
function v(o) {
  const s = n`grid-cols-2`, { columnsCount: t } = m(o), r = {
    1: n`md:grid-cols-1`,
    2: n`md:grid-cols-2`,
    3: n`md:grid-cols-3`,
    4: n`md:grid-cols-4`,
    6: n`md:grid-cols-6`,
    8: n`md:grid-cols-8`
  }[t];
  return [s, r];
}
const b = ({
  cardsCount: o,
  cardIndex: s
}) => c(o) && s === 0;
function y({
  cardsCount: o,
  cardIndex: s
}) {
  const t = n`flex`, i = b({ cardIndex: s, cardsCount: o }) ? n`col-span-2` : n`col-span-1`, { nthElementShifted: r, doubleColumns: l } = m(o), e = n`${l ? n`md:col-span-2` : n`md:col-span-1`}`;
  return s === r ? [i, n`${e} md:col-start-2`, t] : [i, e, t];
}
export {
  w as buildFluidLayoutRows,
  y as fluidLayoutCardClass,
  v as fluidLayoutListClass
};
